import Vue from 'vue';
import Vuex, { ActionTree, MutationTree } from 'vuex';
import { Howl, Howler } from 'howler';

interface LocalState {
  muted: boolean;
  music: Howl;
  musicInstance: number | undefined;
}

Vue.use(Vuex);

const normalMusicVolume = 0.75;

const wasMutedPreviously = localStorage.getItem('nxw-muted') === 'true';

Howler.mute(wasMutedPreviously);

const namespaced = true;

const localState: LocalState = {
  muted: wasMutedPreviously,
  music: new Howl({
    src: ['/assets/audio/background-ambience.mp3'],
    preload: false,
    autoplay: false,
    loop: true,
  }),
  musicInstance: undefined,
};

const mutations: MutationTree<LocalState> = {
  SET_AUDABILITY: (state, audability: boolean) => {
    Vue.set(state, 'muted', !audability);
    localStorage.setItem('nxw-muted', (!audability).toString());
  },
  SET_MUSIC_INSTANCE: (state, musicInstance: number) => {
    Vue.set(state, 'musicInstance', musicInstance);
  },
};

const actions: ActionTree<LocalState, unknown> = {
  LOAD_MUSIC: (context) => {
    context.state.music.once('load', () => Promise.resolve());
    context.state.music.once('loaderror', () => Promise.reject());
    context.state.music.load();
  },

  PLAY_MUSIC: (context) => {
    context.commit(
      'SET_MUSIC_INSTANCE',
      context.state.music.play(context.state.musicInstance)
    );
    context.state.music.fade(0, normalMusicVolume, 500);
  },

  PAUSE_MUSIC: (context) => {
    context.state.music.fade(normalMusicVolume, 0, 500);
    context.state.music.once('fade', () =>
      context.state.music.pause(context.state.musicInstance)
    );
  },

  SET_AUDABILITY: (context, audible: boolean) => {
    const muted = !audible;
    Howler.mute(muted);
    context.commit('SET_AUDABILITY', audible);
  },
};

export { namespaced, localState as state, mutations, actions };
